import React, { useMemo, useState } from 'react'
import { SpinLoading } from 'antd-mobile'
import BridgeFormResultDetailModal, {
  resolveFormValue
} from '../WorkoutDetails/BridgeFormResultDetailModal'
import '../styles/BridgeCard.css'

const FormGroupCard = ({ group, onSelect }) => {
  const latest = group.records[0]
  const latestValue = resolveFormValue(latest)
  const latestDisplay =
    latestValue !== '—' && latest.unit_used
      ? `${latestValue} ${latest.unit_used}`
      : latestValue

  return (
    <div className="bridge-set-card" onClick={() => onSelect(group)}>
      <div className="bridge-set-card-header">
        <div className="bridge-set-card-main">
          <p className="bridge-set-title">{group.formName}</p>
          <p className="bridge-set-subtitle">
            {group.records.length} response{group.records.length === 1 ? '' : 's'}
            {latest.question ? ` · ${latest.question}: ${latestDisplay}` : ''}
          </p>
        </div>
        <div className="bridge-set-card-right">
          <span className="bridge-chevron">›</span>
        </div>
      </div>
    </div>
  )
}

export default function BridgeFormCard({ records, loading, error }) {
  const [selectedGroup, setSelectedGroup] = useState(null)

  const groups = useMemo(() => {
    const map = new Map()
    ;(records || []).forEach((record) => {
      const key =
        record.form_id != null
          ? String(record.form_id)
          : `form-${record.form_name || 'unknown'}`
      if (!map.has(key)) map.set(key, [])
      map.get(key).push(record)
    })

    return Array.from(map.entries()).map(([formId, formRecords]) => {
      // most recent first (for the "latest answer" preview)
      const sorted = [...formRecords].sort((a, b) => {
        if (!a.recorded_at) return 1
        if (!b.recorded_at) return -1
        return String(b.recorded_at).localeCompare(String(a.recorded_at))
      })
      return {
        formId,
        formName: (sorted[0] && sorted[0].form_name) || `Form #${formId}`,
        records: sorted
      }
    })
  }, [records])

  if (loading) {
    return (
      <div className="bridge-loading">
        <SpinLoading color="default" /> Loading form results...
      </div>
    )
  }

  if (error) {
    return (
      <p className="bridge-no-data">Failed to load form results. Please try again later.</p>
    )
  }

  if (!records || records.length === 0 || groups.length === 0) {
    return (
      <div className="bridge-empty-card">
        <p className="bridge-no-data">No form results for this day.</p>
      </div>
    )
  }

  return (
    <div>
      {groups.map((group) => (
        <FormGroupCard
          key={group.formId}
          group={group}
          onSelect={setSelectedGroup}
        />
      ))}

      <BridgeFormResultDetailModal
        visible={!!selectedGroup}
        onClose={() => setSelectedGroup(null)}
        formName={selectedGroup?.formName}
        records={selectedGroup?.records}
      />
    </div>
  )
}
